// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { productPriceAndActionsStyle } from "@sc/App/Components/Product/ProductPriceAndActions";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

productPriceAndActionsStyle.productGridContainer = {
    container: {
        css: css`
            max-width: 100%;
        `,
    },
    availability: {
        css: css`
            min-height: 26px;
            margin-bottom: 8px;
            ${xScreen("lte", 767)} {
                height: auto;
            }
        `,
    },
    price: {
        css: css`
            margin-bottom: 8px;
        `,
    },
};

productPriceAndActionsStyle.priceBadgesContainer = {
    css: css`
        &:empty {
            display: none;
        }
    `,
};

productPriceAndActionsStyle.productListProductImageStyles = {
    wrapper: {
        css: css`
            width: auto;
        `,
    },
    compareCheckbox: {
        css: css`
            padding-top: 0;
            margin: 0;
            span[role="checkbox"] + label {
                margin-left: 8px;
            }
        `,
    },
};
productPriceAndActionsStyle.productAddToListStyles = {
    link: {
        css: css`
            margin-left: auto;
        `,
    },
};
